import { render, staticRenderFns } from "./ContratoCarenciaItem.vue?vue&type=template&id=eda5c08c&scoped=true"
import script from "./ContratoCarenciaItem.vue?vue&type=script&lang=js"
export * from "./ContratoCarenciaItem.vue?vue&type=script&lang=js"
import style0 from "./ContratoCarenciaItem.vue?vue&type=style&index=0&id=eda5c08c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda5c08c",
  null
  
)

export default component.exports